import React, { Component } from 'react';
import { Col, Container, Row, Card, CardBody, Nav, NavItem, NavLink } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ItemMasterComponent from './components/viewTaxItemsDetails';
import HorizontalFormView from '../alternateView/components/alternateView';
import TaxMaster from '../TaxMaster/components/taxMaster';
import "../../global.css";

class viewTaxItemsDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'tax_master'
    };
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  render() {
    const { t } = this.props;
    const { activeTab } = this.state;

    return (
      <Container>
        
        <Row>
          <Col md={12} id="master_tab_container" className="master_tab_container">
           
                <Nav style={{backgroundColor: '#fff', marginBottom: 6, paddingLeft: 0}} tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active1: activeTab === 'item_list' })}
                      style={activeTab === 'item_list' ? { backgroundColor: '#FEF1CC', margin: 0 } : {}}
                      onClick={() => this.toggleTab('item_list')}
                    >
                      Item List
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active1: activeTab === 'map_tax' })}
                      style={activeTab === 'map_tax' ? { backgroundColor: 'yellow', border: '2px solid darkgoldenrod' } : {}}
                      onClick={() => this.toggleTab('map_tax')}
                    >
                      Map Tax
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      className={classnames({ active1: activeTab === 'tax_master' })}
                      style={activeTab === 'tax_master' ? { backgroundColor: 'yellow', border: '2px solid darkgoldenrod' } : {}}
                      onClick={() => this.toggleTab('tax_master')}
                    >
                      Tax Master
                    </NavLink>
                  </NavItem>
                </Nav>
              
          </Col>
        </Row>

        
        <Row>
          <Col md={12}>
           
                {activeTab === 'item_list' ? "" : activeTab === 'map_tax' ? "" : <ItemMasterComponent />}
             
          </Col>
        </Row>
      </Container>
    );
  }
}

viewTaxItemsDetails.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(viewTaxItemsDetails);